<template>
  <pre style="text-align: left">{{ JSON.stringify(data, null, 4) }}</pre>
</template>

<script>
  export default {
    name: 'Debug',

    props: {
      data: Object,
    },
  };
</script>
